import { render, staticRenderFns } from "./Select-Entity.vue?vue&type=template&id=24c54cb9&scoped=true&"
import script from "./Select-Entity.vue?vue&type=script&lang=js&"
export * from "./Select-Entity.vue?vue&type=script&lang=js&"
import style0 from "./Select-Entity.vue?vue&type=style&index=0&id=24c54cb9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c54cb9",
  null
  
)

export default component.exports